<template>
  <div class="content forumList">
    <template>
      <el-tabs>
        <template v-for="(item, index) in tabData">
          <el-tab-pane :label="item" :key="index">
            <div class="bodycontent" v-loading="loading">
              <!-- 头部菜单 -->
              <div class="option">
                <div class="left">
                  <el-button icon="el-icon-plus" type="primary" size="small" @click="addPosts">发布帖子</el-button>
                </div>
              </div>
              <!-- 筛选模块 -->
              <div class="screen">
                <el-row :gutter="10">
                  <el-col :span="2">
                    <div class="grid-content">
                      <span>关键词</span>
                    </div>
                  </el-col>
                  <el-col :span="3">
                    <div class="grid-content">
                      <el-select v-model="value" placeholder="请选择" size="small">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </el-col>
                  <el-col :span="3">
                    <div class="grid-content">
                      <el-input v-model="value" size="small"></el-input>
                    </div>
                  </el-col>
                  <el-col :span="3">
                    <div class="grid-content" style="textAlign:left">
                      <el-button type="primary" size="small">筛选</el-button>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <!-- 列表 -->
              <template>
                <el-table
                  ref="multipleTable"
                  :data="tableData"
                  tooltip-effect="dark"
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
                  border
                >
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column label="帖子内容" min-width="120">
                    <template slot-scope="scope"><p v-html="scope.row.detail" class="details"></p></template>
                  </el-table-column>
                  <el-table-column prop="plateClass" label="帖子分类" width="180"></el-table-column>
                  <el-table-column label="帖子信息" width="180">
                    <template slot-scope="scope">
                      <p>分享：{{ scope.row.infor.share }}</p>
                      <p>点赞：{{ scope.row.infor.share }}</p>
                      <p>浏览：{{ scope.row.infor.share }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column prop="time" label="发帖时间" width="180"></el-table-column>
                  <el-table-column prop="name" label="发帖人" width="180"></el-table-column>
                  <el-table-column prop="state" label="帖子状态" width="80">
                    <template slot-scope="scope">
                      <el-tag type="success" size="small" v-if="scope.row.state.placedTop == 1">置顶中</el-tag>
                      <el-tag type="success" size="small" v-else-if="scope.row.state.placedTop == 2">不置顶</el-tag>
                      <el-tag type="success" size="small" v-if="scope.row.state.essence == 1">精华</el-tag>
                      <el-tag type="success" size="small" v-if="index == 2">显示中</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="address" label="地址" width="180"></el-table-column>
                </el-table>
                <div style="margin-top: 20px">
                  <el-button
                    @click="toggleSelection([tableData[1], tableData[2]])"
                    size="small"
                  >通过选中帖子</el-button>
                  <el-button @click="toggleSelection()" size="small">关闭选中帖子</el-button>
                  <el-button @click="toggleSelection()" size="small">删除选中帖子</el-button>
                </div>
              </template>
            </div>
          </el-tab-pane>
        </template>
      </el-tabs>
    </template>
    <!-- 分页按钮 -->
    <div class="Otherpage">
      <el-pagination
        layout="prev, pager, next, total, jumper"
        :current-page="page"
        :total="total"
        :page-size="10"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page_id: "",
      listData: [], //列表
      page: 1,
      total: 0,
      loading: false, //页面loading
      tabData: ["所有帖子", "待审核", "显示中", "置顶中", "未通过", "已删除"],
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      tableData: [
        {
          detail: "手动阀手动阀手动阀的士速递",
          plateClass: "王小虎",
          infor: {
            share: 0,
            like: 0,
            browse: 0
          },
          time: "2020-01-14",
          name: "sdfds",
          state: {
            placedTop: 1,
            essence: 1
          }
        }
      ],
      multipleSelection: []
    };
  },
  mounted() {
    this.page_id = this.$route.params.id;
    this.getlocalData();
  },
  methods: {
    getlocalData() {
      this.tableData = JSON.parse(localStorage.getItem("forumList"))
    },
    addPosts() {
      this.$router.push({
        path: `/apply/forum/${this.page_id}/addPosts`
      });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //跳页
    handleCurrentChange(p) {
      this.page = p;
    }
    //编辑
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
  .bodycontent {
    margin-top: -10px;
    position: relative;
    padding: 0px 27px 0;
    font-size: 14px;
    height: 96%;
    display: flex;
    flex-direction: column;
    .option {
      height: 50px;
      line-height: 50px;
      display: flex;
      .left {
        flex: 1;
      }
    }
    .screen {
      padding: 10px 0;
      margin-bottom: 15px;
      background-color: #f8f8f8;
      .grid-content {
        min-height: 32px;
        line-height: 32px;
        text-align: center;
      }
    }
  }
  .details {
    width: 100%;
    max-height: 100px;
    overflow: auto;
  }
  //分页
  .Otherpage {
    margin-top: 20px;
    height: 34px;
    line-height: 34px;
    padding-left: 15px;
  }
}
</style>

<style lang="scss">
.forumList {
  .el-tabs__nav-scroll {
    padding-left: 25px;
  }
  .has-gutter > tr > th {
    background: #f8f8f8;
  }
  .cell {
    text-align: center;
  }
}
</style>